<template>
  <div style="padding-bottom: 50px;">
    <banner />
    <tabs @changeTab="handleChangeTab" />

    <div class="level">
      <!-- HSK -->
      <section v-if="activeKey === 'hsk_levels'" class="hsk">
        <!-- <img src="@/assets/images/chooselevel/hsk.png" alt="" class="logo-image" /> -->
        <!-- <div class="hsk-text">
          <p v-html="$t('level_HSK_text1')"></p>
          <p>{{ $t('level_HSK_text2') }}</p>
        </div> -->
        <div class="choose">
          <div class="choose-wrap">
            <!-- <div class="choose-wrap__top hsk-wrap__top">
              <span>{{ $t('level_BEGINNER') }}</span>
              <span>{{ $t('level_INTERMEDIATE') }}</span>
              <span>{{ $t('level_ADVANCED') }}</span>
            </div> -->
            <div class="choose-wrap__middle">
              <div
                class="item"
                v-for="level in HSKbuttons"
                :key="level.id"
                :class="{ active: level.id == currentLevelActiveId, compact_button: compactStyle }"
              >
                <div>{{ level.level_name }}</div>
<!--                <div>{{ getClass('hsk_levels', level.level_id) }}</div>-->
                <div
                  class="start-btn"
                  @click="jumpExamination(level, levelTypeList[0]?.level_type || 1)"
                >
                  {{ $t('hsk_start_exam_new') }}
                </div>
              </div>
              <div class="item empty">
                <p class="guide" v-html="$t('level_des')"></p>
              </div>
            </div>
            <!-- <div class="choose-wrap__bottom">
              <img src="@/assets/images/chooselevel/arrow.png" alt="" />
            </div> -->
          </div>
        </div>
      </section>
      <!-- HSKK -->
      <section v-if="activeKey === 'hsk_speaking'" class="hskk">
        <div class="choose">
          <div class="choose-wrap">
            <div class="choose-wrap__middle">
              <div
                class="item"
                v-for="(level, levelIndex) in HSKKbuttons"
                :key="level.id"
                :class="{ active: level.id == currentLevelActiveId }"
              >
                <div>{{ getClass('hsk_speaking', level.level_id) }}</div>
                <div
                  v-html="
                    levelIndex === 0
                      ? $t('for_hsk3_condidates')
                      : levelIndex === 1
                      ? $t('for_hsk4_condidates')
                      : levelIndex === 2
                      ? $t('for_hsk56_condidates')
                      : ''
                  "
                ></div>
                <div
                  class="start-btn"
                  @click="jumpExamination(level, levelTypeList[1]?.level_type || 1)"
                >
                  {{ $t('hsk_start_exam_new') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- YCT -->
      <section v-if="activeKey === 'yct'" class="yct">
        <div class="choose">
          <div class="choose-wrap">
            <div class="choose-wrap__middle">
              <div
                class="item"
                v-for="level in YCTbuttons"
                :key="level.id"
                :class="{ active: level.id == currentLevelActiveId, compact_button: compactStyle }"
              >
                <div>{{ level.level_name }}</div>
<!--                <div>{{ getClass('yct', level.level_id) }}</div>-->
                <div
                  class="start-btn"
                  @click="jumpExamination(level, levelTypeList[2]?.level_type || 1)"
                >
                  {{ $t('hsk_start_exam_new') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 弹窗 -->
      <DialogTest :visible="centerDialogVisible" @update:visible="dialogUpdate"></DialogTest>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import DialogTest from '@/components/DialogTest'
// import { getToken } from "@/utils/cache";
import { mixinLanguage } from '@/mixins'
import analytics from '@/utils/AnalyticsCenter'
import Banner from './banner'
import Tabs from './tabs'

export default {
  name: 'LevelChoose',
  data() {
    return {
      activeKey: 'hsk_levels',
      // hsk当期选择的内容
      HSKselectedIndex: null,
      // hsk当期选择的内容
      YCTselectedIndex: null,
      // 是否显示弹窗
      centerDialogVisible: false,
    }
  },
  mixins: [mixinLanguage],
  computed: {
    ...mapState({
      // 等级信息
      levelTypeList: (state) => state.level.levelList,
      currentLevelActiveId: (state) => state.level.levelActive,
      levelActiveIndex: (state) => state.level.levelActiveIndex,
    }),
    ...mapGetters('level', {
      levelTypeName: 'levelTypeName',
    }),
    HSKbuttons() {
      return this.levelTypeList[0]?.levels
    },
    HSKKbuttons() {
      return this.levelTypeList[1]?.levels
    },
    YCTbuttons() {
      return this.levelTypeList[2]?.levels
    },
    // 有测过的等级
    isGrading() {
      return this.$store.state.grade.isGrading
    },
    compactStyle() {
      let local = localStorage.getItem('language')
      if (local == 'mn') {
        return false
      }
      return false
    },
  },
  components: {
    DialogTest,
    Banner,
    Tabs,
  },
  mounted() {
    analytics.logEvent('hskweb_levelchoose_view')
    // 找到所有带有 'clickable' 类的元素
    const clickableElements = this.$el.querySelectorAll('.clickable')
    // 为每个元素添加点击事件
    clickableElements.forEach((element) => {
      element.addEventListener('click', this.judgeLink)
    })

    console.log('this.levelTypeList', this.levelTypeList)
  },
  methods: {
    getClass(key, levelId) {
      const hsk_level_class = new Map([
        [this.$t('level_BEGINNER'), [1, 2, 3]],
        [this.$t('level_INTERMEDIATE'), [4, 5, 6]],
        [this.$t('level_ADVANCED'), [7]],
      ])
      const hsk_speaking_class = new Map([
        [this.$t('level_PRIMARY'), [1]],
        [this.$t('level_INTERMEDIATE'), [2]],
        [this.$t('level_ADVANCED'), [3]],
      ])
      const yct_class = new Map([
        [this.$t('level_BEGINNER'), [1, 2]],
        [this.$t('level_INTERMEDIATE'), [3, 4]],
      ])

      const data = {
        hsk_levels: hsk_level_class,
        hsk_speaking: hsk_speaking_class,
        yct: yct_class,
      }

      const _map = data[key]

      let className = null

      Array.from(_map.keys()).forEach((levelName) => {
        const value = _map.get(levelName)
        if (value.includes(levelId)) {
          className = levelName
        }
      })

      return className
    },
    handleChangeTab(key) {
      this.activeKey = key
    },
    HSKselectButton(index) {
      this.HSKselectedIndex = index
    },
    YCTselectButton(index) {
      this.YCTselectedIndex = index
    },
    // 等级跳转方法
    jumpExamination(newActive, newLevelType) {
      this.$store
        .dispatch('level/changeLevel', {
          levelType: newLevelType,
          levelId: newActive.id,
          levelIndex: newActive.level_id,
        })
        .then(() => {
          const params = {
            level: this.levelTypeName + this.levelActiveIndex,
          }
          analytics.logEvent('hskweb_levelchoose_click', params)
          // if (!["OnlinePracticeIndex", "vocabulary", "HSKExamination"].includes(this.$router?.history?.current?.name)) {
          // this.$router.push({
          //   path: `/${this.levelTypeName || 'hsk'}/index`,
          //   // query: {
          //   //   level_id: newActive.id,
          //   // },
          // })
          this.$router.push({
            path: `/${this.levelTypeName || 'hsk'}/tests`,
            query: {
              level: `${this.levelTypeName}${this.levelActiveIndex}`,
            },
          })
          // }
        })
    },
    // 点击免费测试按钮
    judgeLink() {
      analytics.logEvent('hskweb_leveltest_click')
      // 完成过等级测试跳转等级结果页面
      if (this.isGrading) {
        this.$router.push({
          name: 'levelReport',
        })
      } else {
        this.centerDialogVisible = true
      }
    },
    // 弹窗显示状态发生变化
    dialogUpdate(val) {
      this.centerDialogVisible = val
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@//styles/variables.scss';

.level {
  h1 {
    color: #2c2f46;
    font-family: Calibri;
    font-size: 40px;
    font-weight: 700;
    margin-top: 24px;
    text-align: center;
  }
  .guide {
    color: #696974;
    font-family: Calibri;
    font-size: 16px;
    font-weight: 400;
    margin: 12px 0 20px;
    text-align: center;
    b {
      color: #000;
      font-weight: 700;
      cursor: pointer;
    }
  }
  section {
    height: 460px;
    flex-shrink: 0;
    border-radius: 18px;
    overflow: hidden;
    .logo-image {
      display: block;
      height: 140px;
      width: 140px;
      margin: 50px auto 0;
    }
    .hsk-text,
    .hskk-text,
    .yct-text {
      text-align: center;
      color: #474b64;
      font-family: Calibri;
      font-size: 14px;
      margin: 20px 0 28px;
      b {
        color: #474b64;
        text-align: center;
        font-size: 14px;
        font-weight: 700;
      }
    }
    // 选择框
    .choose {
      // height: 130px;
      // background: #4d8346;
      padding-top: 60px;
      display: flex;
      justify-content: center;
      &-wrap {
        display: inline-block;
        height: 100%;
        width: 838px;
        &__top {
          margin: 22px 0;
          color: #fff;
          font-family: Calibri;
          font-size: 14px;
          font-weight: 700;
          &.hsk-wrap__top {
            span {
              width: 202px;
              display: inline-block;
              text-align: center;
              margin-right: 63px;
              &:last-of-type {
                width: 323px;
                margin-right: 0px;
              }
            }
          }
          // &.hsk-warp__top_compact{
          //   span {

          //     margin-right: 63px;

          //   }
          // }
          &.yct-wrap__top {
            span {
              width: 240px;
              display: inline-block;
              text-align: center;
              margin-right: 77px;
              &:last-of-type {
                margin-right: 0px;
              }
            }
          }
        }
        &__middle {
          // height: 26px;
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          grid-template-rows: repeat(2, minmax(0, 1fr));
          grid-gap: 35px 25px;

          .item {
            background: #fff;
            padding: 28px 30px;
            box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.1);
            border-radius: 14px;
            display: flex;
            flex-direction: column;
            align-items: center;
            border-radius: 15px;
            font-family: Calibri;

            & > div:nth-of-type(1) {
              font-size: 26px;
              font-weight: 600;
              padding-top: 10px;
            }
            & > div:nth-of-type(2) {
              font-size: 20px;
              line-height: 32px;
              color: #2d2f47;
            }

            & > .start-btn {
              background: $yellow;
              color: #fff!important;
              width: 110px;
              height: 30px;
              line-height: 29px;
              text-align: center;
              font-size: 18px!important;
              margin-top: 20px;
              border-radius: 15px;
              cursor: pointer;
            }

            &.empty {
              box-shadow: none;
              background: transparent;
              display: flex;
              flex-direction: column;
              justify-content: center;
              min-height: 153px;
              padding: 8px;

              & > p {
                margin: 0;
              }
            }
          }

          .button {
            display: inline-block;
            width: 81px;
            height: 26px;
            line-height: 24px;
            border-radius: 50px;
            border: 1px solid #fffefe;
            color: #fff;
            text-align: center;
            font-family: Calibri;
            font-size: 14px;
            cursor: pointer;
            margin-right: 77px;
            &:last-of-type {
              margin: 0;
            }
            &:hover,
            &.active {
              border-radius: 50px;
              background: #fffcfc;
              color: #2c2f46;
            }
          }

          // .hsk-button:nth-child(2),
          // .hsk-button:nth-child(4){
          //   margin-right:63px;
          // }
        }
        &__bottom {
          margin-top: 15px;
        }
      }
    }
    &.hsk {
      // background: #dce7da;
      margin-bottom: 20px;
      .choose-wrap__middle {
        .button {
          margin-right: 40px;
          &:last-of-type {
            margin: 0;
          }
        }
        .button:nth-child(2),
        .button:nth-child(4) {
          margin-right: 63px;
        }
        .compact_button {
          margin-right: 30px;
          width: auto;
          padding: 0 4px;
          &:last-of-type {
            margin: 0;
          }
        }
        .compact_button:nth-child(2),
        .compact_button:nth-child(4) {
          margin-right: 50px;
        }
      }
    }
    &.hskk {
      // background: #dce7da;
      margin-bottom: 20px;
      .choose {
        position: relative;
      }
      .choose-wrap__middle {
        grid-template-columns: repeat(3, 1fr);
        // padding: 0 4px;
        // margin-top: 30px;
        .item {
          & > div:nth-of-type(2) {
            margin-top: 12px;
            line-height: 25px;
            text-align: center;
          }
        }

        .button {
          width: 129px;
          margin-right: 233px;
          &:last-of-type {
            margin: 0;
          }
        }
      }
      .choose-wrap__bottom {
        p {
          text-align: center;
          color: #fff;
          position: absolute;
          bottom: 10px;
          left: 50%;
          transform: translate(-50%);
          // white-space: nowrap;
          width: 1200px;
          word-break: break-word;
        }
      }
    }
    &.yct {
      // background: #f4e2d4;
      margin-bottom: 20px;
      .choose {
        // background: #c97025;
      }
      .choose-wrap__middle {
        padding: 0 6px;
      }
      .compact_button {
        width: auto;
        padding: 0 4px;
      }
    }
  }
}
/*右箭头*/
.arrow-right {
  height: 120px;
  width: 60px;
  display: inline-block;
  position: relative;
}
.arrow-right::after {
  content: '';
  height: 60px;
  width: 60px;
  top: 12px;
  border-width: 8px 8px 0 0;
  border-color: blue;
  border-style: solid;
  transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
  position: absolute;
}

@media (max-width: 768px) {
  section {
    height: auto !important;

    .choose {
      padding-top: 30px !important;

      &-wrap {
        &__middle {
          grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
          padding: 0px 20px 20px 20px !important;
        }
      }
    }
  }
}
</style>
